import customersServices from "src/api-services/customers-services";
import { showResponseMessage } from "../Components/utils/handellApiResponse";

export const createCustomersSlice = (set) => ({
  customers: [],
  customersLoading: false,
  customer: {},
  customerLoading: false,
  customersPagination: {
    current_page: 1,
    last_page: 1,
    per_page: 10,
    total: 0,
  },

  fetchCustomerFunction: async () => {
    set((state) => ({
      ...state,
      customersLoading: true,
    }));
    try {
      const response = await customersServices.getCustomers();

      set((state) => ({
        ...state,
        customers: response.data.data.data,
        customersLoading: false,
        customersPagination: response.data.data.pagination,
      }));
    } catch {
      set((state) => ({
        ...state,
        customersLoading: false,
      }));
    }
  },
  insertCustomerFunction: async (data) => {
    set((state) => ({
      ...state,
      customersLoading: true,
    }));
    try {
      const response = await showResponseMessage(
        customersServices.storeCustomer(data),
        "store"
      );
      set((state) => ({
        ...state,
        customers: [...state.customers, response.data.data],
        customersLoading: false,
      }));
    } catch {
      set((state) => ({
        ...state,
        customersLoading: false,
      }));
    }
  },
  updateCustomerFunction: async (data) => {
    set((state) => ({
      ...state,
      customersLoading: true,
    }));
    try {
      const response = await showResponseMessage(
        customersServices.updateCustomer(data),
        "update"
      );
      set((state) => ({
        ...state,
        customers: [...state.customers, response.data.data],
        customersLoading: false,
      }));
    } catch {
      set((state) => ({
        ...state,
        customersLoading: false,
      }));
    }
  },
  deleteCustomerFunction: async (id) => {
    set((state) => ({
      ...state,
      customersLoading: true,
    }));
    try {
      const response = await showResponseMessage(
        customersServices.deleteCustomer(id),
        "delete"
      );
      set((state) => ({
        ...state,
        customers: state.customers.filter((e) => e.id !== id),
        customersLoading: false,
      }));
    } catch {
      set((state) => ({
        ...state,
        customersLoading: false,
      }));
    }
  },
  searchCustomerFunction: async (data) => {
    set((state) => ({
      ...state,
      customersLoading: true,
    }));
    try {
      const response = await customersServices.searchCustomer(data);
      set((state) => ({
        ...state,
        customers: response.data.data.data,
        customersLoading: false,
        customersPagination: response.data.data.pagination,
      }));
    } catch {
      set((state) => ({
        ...state,
        customersLoading: false,
      }));
    }
  },
  setCustomer: (customer) => {
    set((state) => ({
      ...state,
      customer: customer,
    }));
  },
  setCustomersPagination: (customersPagination) => {
    set((state) => ({
      ...state,
      customersPagination: customersPagination,
    }));
  },
});
